import {ICurrentVan} from "./ICurrentVan";
import {Van} from "../../../../../server/src/base/entities/leasing/Van";
import {UserReservation} from "../../../../../server/src/base/entities/leasing/calendar/UserReservation";

export class CurrentVan implements ICurrentVan{

    private vans:Array<Van>;
    private currentIndex:number;

    constructor(vans: Array<Van>, userReservation:UserReservation = null) {
        this.vans = vans;
        this.currentIndex = 0;
        if(userReservation != null){
            for(let i = 0 ; i < this.vans.length ; ++i){
                if(this.vans[i].id == userReservation.vanId){
                    this.currentIndex = i;
                    break;
                }
            }
        }
    }

    public Value(): Van {
        return this.vans[this.currentIndex];
    }

    public Next():boolean {
        if(this.currentIndex < this.vans.length - 1) {
            this.currentIndex++;
            return true;
        }
        return false;
    }

    public Previous():boolean {
        if(this.currentIndex > 0) {
            this.currentIndex--;
            return true;
        }
        return false;
    }

    Position():number{
        return this.currentIndex + 1;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/leasing/CurrentVan.ts